import * as KeyTokenServices from '../services/templateServices/KeyTokenServices'
import http from './http';

export const GetCookieValue = (cookie) => {
    var cookieArr = document.cookie.split(";");
    for(var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");
        if(cookie === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}

//Descpt una Cookie
export const DesencryptKeyToken = async (cookie) => {
    let Data = await KeyTokenServices.DesencryptKeyToken(GetCookieValue(cookie));
    return Data;
}


export const DesencryptKey = async (Key) => {
    let Data = await KeyTokenServices.DesencryptKeyToken(Key);
    return Data;
}

export const EncryptKeyToken = async (Key) => {
    let Data = await KeyTokenServices.EncryptKeyToken(Key);
    return Data
}

export const setAuthorizationHeader = token => http.defaults.headers.common ['Authorization'] = `Bearer ${token}`

export const removeAuthorizationHeader = ( ) => delete http.defaults.headers.common ['Authorization'];
